export const USER_SERVICE = "https://user-service-production-43f5.up.railway.app";
export const CART_SERVICE = "https://cart-service-production-6202.up.railway.app";
export const ORDER_SERVICE = "https://order-service-production-293a.up.railway.app";
export const QUERY_SERVICE = "https://query-service-production.up.railway.app";
